export enum ACTIONS {
  SET_LAST_WINNERS = 'SET_LAST_WINNERS',
  ADD_NEW_ROUND_RESULT = 'ADD_NEW_ROUND_RESULT',
}

export interface ILastWinnersState {
  lastWinners: string[];
}
